/**
 * 프로덕션 환경에서 console.log를 비활성화하는 로거
 * 개발 환경에서만 로그 출력
 */

const isDev = process.env.NODE_ENV === 'development'

export const logger = {
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args)
    }
  },

  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args)
    }
  },

  warn: (...args: any[]) => {
    // 경고도 개발 환경에서만 출력
    if (isDev) {
      console.warn(...args)
    }
  },

  error: (...args: any[]) => {
    // 에러는 항상 출력
    console.error(...args)
  },

  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args)
    }
  }
}

export default logger
